/**
 * Print System Feature - Main Export
 */

import { printService } from './services/printService.js';

export const initPrintSystemServices = () => {
  printService.init();
  console.log('Print System services initialized');
};

export const printSystem = {
  service: printService,

  async printTrip(tripId, userId, template = 'tripSummary', format = 'html', options = {}) {
    return printService.handlePrintRequest({
      payload: {
        printId: `print-${Date.now()}`,
        userId,
        tripId,
        template,
        format,
        options
      }
    });
  },

  async previewPrint(tripId, userId, template, format, options = {}) {
    return printService.handlePreviewRequest({
      payload: {
        previewId: `preview-${Date.now()}`,
        userId,
        tripId,
        template,
        format,
        options
      }
    });
  },

  getAvailableTemplates() {
    return printService.getAvailableTemplates();
  },

  getTemplateFormats(templateId) {
    return printService.getTemplateFormats(templateId);
  }
};

export { printService };
export default printSystem;